<template>
  <div class="pager-table-container clearfix">
    <el-table
      :data="data"
      :border="border"
      :stripe="stripe"
      :size="size"
      :height="height"
      :row-style="rowStyle"
      @selection-change="handleSelectionChange"
      @select="handleSelect"
      @sort-change="handleSortChange"
    >
      <!-- empty data -->
      <template slot="empty">
        <span class="empty-data">空数据</span>
      </template>

      <!-- multiple checkbox -->
      <el-table-column
        v-if="multipleComputed"
        type="selection"
        :selectable="checkBoxDisable"
        align="center"
        :width="multiple.width || 55"
        :fixed="multiple.fixed || 'left'"
      />

      <!-- show index number -->
      <el-table-column
        v-if="serialComputed"
        type="index"
        align="center"
        :label="serial.label || '编号'"
        :width="serial.width || 65"
        :fixed="serial.fixed || 'left'"
      />

      <!-- columns list -->
      <el-table-column
        v-for="(col, index) in columns"
        show-overflow-tooltip
        :key="index"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        :min-width="col.minWidth"
        :align="col.align"
        :fixed="col.fixed"
        :sortable="col.sort ? 'custom' : false"
      >
        <template slot-scope="scope">
          <template v-if="col.render && typeof col.render === 'function'">
            <custom-expand :render="col.render" :row="scope.row" :index="index" />
          </template>
          <template v-else-if="col.formatter && typeof col.formatter === 'function'">
            <div v-html="col.formatter(scope.row, scope.$index)"></div>
          </template>
          <template v-else>{{scope.row[col.prop]}}</template>
        </template>
      </el-table-column>

      <!-- actions button -->
      <el-table-column
        v-if="actions.btnGroup && actions.btnGroup.length > 0"
        :label="actions.label || '操作'"
        :width="actions.width"
        :min-width="actions.minWidth"
        :fixed="actions.fixed"
        :align="actions.align"
      >
        <template slot-scope="scope">
          <template v-for="(btn, index) in actions.btnGroup">
            <el-button
              v-if="btnShowComputed(btn.show, scope)"
              :key="index"
              :plain="btn.plain"
              :size="btn.size || 'small'"
              :disabled="btn.disabled"
              :icon="btn.icon"
              :round="btn.round"
              :circle="btn.circle"
              :type="btnTypeComputed(btn.type, scope)"
              @click.native.prevent="btn.callback && btn.callback(scope.row, scope.$index)"
            >{{ btnTitleComputed(btn.title, scope) }}</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="showPager" class="pull-right">
      <jr-pagination :total="total" :page.sync="page" :limit.sync="rows" @pagination="handlePagination" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'JR_Table',
  props: {
    data: {
      required: true,
      type: Array,
    },
    columns: {
      required: true,
      type: Array,
    },
    actions: {
      type: Object,
      default: () => {
        return {
          label: undefined,
          width: undefined,
          minWidth: undefined,
          fixed: false,
          btnGroup: [],
        }
      },
    },
    rowStyle: {
      type: [Function, Object],
    },
    checkBoxDisable: {
      type: [Function, Object],
    },
    serial: {
      type: [Boolean, Object],
      default: () => {
        return false || {}
      },
    },
    multiple: {
      type: [Boolean, Object],
      default: () => {
        return false || {}
      },
    },
    border: {
      type: Boolean,
      default: false,
    },
    stripe: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'medium',
    },
    height: {
      type: [String, Number],
    },
    showPager: {
      type: Boolean,
      default: true,
    },
    total: {
      type: Number,
      default: 0,
    },
    query: {
      type: Object,
      default: () => {
        return {
          page: 1,
          rows: 20,
        }
      },
    },
  },
  components: {
    CustomExpand: {
      functional: true,
      props: {
        render: Function,
        index: Number,
        row: Object,
      },
      render: (h, ctx) => {
        const { row, index } = ctx.props
        return ctx.props.render(h, { row, index })
      },
    },
  },
  computed: {
    page() {
      return this.query.page
    },
    rows() {
      return this.query.rows
    },
    serialComputed() {
      if (typeof this.serial === 'object') {
        return Object.keys(this.serial).length > 0
      }
      return this.serial
    },
    multipleComputed() {
      if (typeof this.multiple === 'object') {
        return Object.keys(this.multiple).length > 0
      }
      return this.multiple
    },
    btnShowComputed() {
      return function (value, scope) {
        if (typeof value === 'undefined') {
          return true
        }
        if (typeof value === 'function') {
          return value(scope.row, scope.$index)
        }
        return value
      }
    },
    btnTitleComputed() {
      return function (title, scope) {
        if (typeof title === 'function') {
          return title(scope.row, scope.$index)
        }
        return title
      }
    },
    btnTypeComputed() {
      return function (type, scope) {
        if (typeof type === 'function') {
          return type(scope.row, scope.$index)
        }
        return type || 'default'
      }
    },
  },
  methods: {
    // selected change multiple checkbox
    handleSelectionChange(val) {
      this.$emit('selectionChange', val)
      // console.log(val)
    },
    // selected multiple checkbox
    handleSelect(selected, row) {
      this.$emit('select', selected, row)
      // console.log(row)
    },
    // async sort
    handleSortChange(val) {
      this.$emit('sortChange', { prop: val.prop, order: val.order })
    },

    // pager query
    handlePagination() {
      this.$emit('pagination')
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
